'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _login = require('./login.html');

var _login2 = _interopRequireDefault(_login);

var _auth = require('./auth.controller');

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loginComponent = {
  restrict: 'E',
  bindings: {},
  template: _login2.default,
  controller: _auth2.default
};

exports.default = loginComponent;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/common/auth/auth.component.js
 **/